export const SET_ADMIN = 'SET_ADMIN';
export const TOGGLE_ADMIN_MODE = 'TOGGLE_ADMIN_MODE';
export const SET_LANGUAGE = 'SET_LANGUAGE';
export const PLAY = 'PLAY';
export const SET_PROGRAM = 'SET_PROGRAM';
export const SET_DATA = 'SET_DATA';


